<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.125 3.25C0.125 1.52411 1.52411 0.125 3.25 0.125H15.75C17.4759 0.125 18.875 1.52411 18.875 3.25V15.75C18.875 17.4759 17.4759 18.875 15.75 18.875H3.25C1.52411 18.875 0.125 17.4759 0.125 15.75V3.25ZM14.9688 9.5C14.9688 9.7072 14.8864 9.90592 14.7399 10.0524L12.3962 12.3962C12.0911 12.7013 11.5964 12.7013 11.2913 12.3962C10.9862 12.0911 10.9862 11.5964 11.2913 11.2913L13.0826 9.5L11.2913 7.70868C10.9862 7.40358 10.9862 6.90892 11.2913 6.60382C11.5964 6.29873 12.0911 6.29873 12.3962 6.60382L14.7399 8.94757C14.8864 9.09409 14.9688 9.2928 14.9688 9.5ZM4.26007 8.94757C4.11356 9.09408 4.03125 9.2928 4.03125 9.5C4.03125 9.7072 4.11356 9.90591 4.26007 10.0524L6.60382 12.3962C6.90892 12.7013 7.40358 12.7013 7.70868 12.3962C8.01377 12.0911 8.01377 11.5964 7.70868 11.2913L5.91735 9.5L7.70868 7.70868C8.01377 7.40358 8.01377 6.90892 7.70868 6.60382C7.40358 6.29873 6.90892 6.29873 6.60382 6.60382L4.26007 8.94757Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCode',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>